// 导入 抽取的 请求对象
import ajaxRequest from '@/utils/request';

const reFix = 'online/IMChannel';

// 获取socket连接地址
export function getSocketUrlApi() {
  let data = 'isCustSer=true';
  return ajaxRequest({
    url: reFix + '/pre-connect',
    method: 'POST',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取楼盘会话列表
export function getHouseChatListApi(params) {
  return ajaxRequest({
    url: reFix + '/cust/house-chan',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取主页会话列表
export function getHomeChatListApi(params) {
  return ajaxRequest({
    url: reFix + '/cust/home-chan',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 客服接入会话
export function joinChanApi(id, areaId) {
  let data = 'chanId=' + id + '&areaId=' + areaId;
  return ajaxRequest({
    url: reFix + '/join-chan',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 发送会话消息
export function sentMsgApi(msg) {
  let data = 'message=' + msg;
  return ajaxRequest({
    url: reFix + '/cust/send-chanmsg',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取聊天记录
export function getChanMsgApi(params) {
  return ajaxRequest({
    url: reFix + '/get-chanmsg',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 结束会话
export function offChanApi(id) {
  let data = 'chanId=' + id;
  return ajaxRequest({
    url: reFix + '/finish-chan',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 上传图片
export function uploadImgApi(data) {
  return ajaxRequest({
    url: '/upload/Images/photo',
    method: 'post',
    data,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 视频上传接口
// URL：/upload/File/uploadVideo
// 参数名：video
// 请求方式：POST

// 上传视频
export function uploadVideoApi(data) {
  return ajaxRequest({
    url: '/upload/File/uploadVideo',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: '*/*',
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 获取未读消息条数
export function msgReadStatusApi(params) {
  return ajaxRequest({
    url: reFix + '/msgReadStatus',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 更新未读消息的状态
export function updateMsgReadStatusApi(params) {
  return ajaxRequest({
    url: reFix + '/updateMsgReadStatus',
    method: 'PUT',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 1、未读消息条数
// URL：/online/IMChannel/msgReadStatus
// 请求方式: GET
// 请求参数: chanId

// 2、更新未读消息的状态
// URL：/online/IMChannel/updateMsgReadStatus
// 请求方式: Put
// 请求参数: chanId
